import Button from "@mui/material/Button";
import weightToggleIcon from "../../assets/icons/weightToggle.png";
import Switch from "@mui/material/Switch";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadWeightToggleState } from "store/features/analysisResultsSlice";

function WeightToggleComponent() {
    const dispatch = useDispatch();

    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const disableWeightToggle = useSelector((state) => state.analysisResultsStore.disableWeightToggle);

    const handleWeightToggleChange = () => {
        dispatch(loadWeightToggleState(!weightToggle));
    };
    return (
        <Button
            size="small"
            className={!disableWeightToggle ? (weightToggle ? "custom-btn custom-btn-outlined-3 color-white me-4 bold-content liner-light-blue-background" : "custom-btn custom-btn-outlined-2 color-blue me-4 bold-content") : "custom-btn me-4 bold-content"}
            disabled={disableWeightToggle}
            variant="outlined"
            startIcon={
                <img
                    className={disableWeightToggle ? "invert" : weightToggle ? "image-white" : ""}
                    style={{
                        height: "16px",
                    }}
                    src={weightToggleIcon}
                />
            }
        >
            Weight
            <Switch
                size="small"
                disabled={disableWeightToggle}
                checked={weightToggle}
                onChange={handleWeightToggleChange}
                sx={{
                    "& .Mui-checked": {
                        "& + .MuiSwitch-track": {
                            backgroundColor: "#ffffff", // Track color when ON
                        },
                    },
                }}
            />
        </Button>
    );
}

export default WeightToggleComponent;
